/**
 * Format a value for displaying on a chart.
 * @param value Numeric value.
 * @returns     Formatted value.
 */
export const formatNumericTickValue = (value: number) => value.toLocaleString(undefined, { maximumFractionDigits: 0 });
